import { IMAGES } from "./content";

export const CATEGORIES = {
  strom: {
    slug: "strom",
    eyebrow: "Stromtarife",
    titleLines: ["Stromkosten senken –", '<span class="font-serif italic text-blue-700">ohne</span> Aufwand.'],
    subtitle: "Unabhängiger Vergleich für Privat & Gewerbe. Wir prüfen Ihren Stromtarif kostenlos und übernehmen auf Wunsch den kompletten Wechsel.",
    image: IMAGES.powerLines,
    intro: "Ob Standardlastprofil (SLP) oder registrierende Leistungsmessung (RLM) – wir analysieren Ihren Stromvertrag individuell und finden über börsennahe Beschaffung den passenden Tarif.",
    benefits: [
      { title: "Börsennahe Beschaffung", text: "Zugang zu Konditionen abseits der Vergleichsportale – oft mit deutlichem Sparpotenzial." },
      { title: "Preisgarantie prüfen", text: "Wir erklären Beschaffungs- und Vertriebspreisgarantien transparent und wählen das Passende." },
      { title: "Wechselservice inklusive", text: "Kündigung, Wechsel und Vertragsabwicklung übernehmen wir komplett für Sie." },
      { title: "Für jede Größe", text: "Vom Ein-Personen-Haushalt bis zum Filialunternehmen mit mehreren Zählpunkten." },
    ],
    stat: { value: "9 / 10", label: "Kunden sparen nach unserer Analyse" },
  },
  gas: {
    slug: "gas",
    eyebrow: "Gastarife",
    titleLines: ["Gasrechnung prüfen", '& <span class="font-serif italic text-blue-700">clever</span> wechseln.'],
    subtitle: "Wir vergleichen Gastarife unabhängig und finden die wirtschaftlich beste Lösung für Ihren Haushalt oder Ihr Unternehmen.",
    image: IMAGES.gas,
    intro: "Gaspreise schwanken stark. Wir prüfen Ihren aktuellen Vertrag, bewerten Laufzeiten und Preisgarantien und sichern günstige Konditionen zum richtigen Zeitpunkt.",
    benefits: [
      { title: "Timing der Beschaffung", text: "Wir beobachten den Markt und empfehlen den passenden Zeitpunkt für Ihren Abschluss." },
      { title: "Transparente Konditionen", text: "Keine versteckten Klauseln – Laufzeiten und Garantien werden verständlich erklärt." },
      { title: "Gewerbe & Industrie", text: "Individuelle RLM-Analyse für Betriebe mit hohem Gasverbrauch." },
      { title: "Rundum-Service", text: "Anbieterwechsel und Kündigung erledigen wir zuverlässig für Sie." },
    ],
    stat: { value: "24 h", label: "bis zu Ihrem individuellen Angebot" },
  },
  photovoltaik: {
    slug: "photovoltaik",
    eyebrow: "Photovoltaik",
    titleLines: ["Sonnenstrom, der", 'sich <span class="font-serif italic text-blue-700">rechnet.</span>'],
    subtitle: "Von der Einspeisung bis zum passenden Reststromtarif – wir beraten unabhängig rund um Ihre PV-Anlage.",
    image: IMAGES.solarHouse,
    intro: "Eine PV-Anlage verändert Ihr Verbrauchsprofil. Wir helfen Ihnen, Eigenverbrauch, Einspeisevergütung und Reststrombezug optimal aufeinander abzustimmen.",
    benefits: [
      { title: "Reststromtarif optimieren", text: "Der passende Tarif für den Strom, den Ihre Anlage nicht selbst deckt." },
      { title: "Einspeisung verstehen", text: "Wir erklären Vergütung und Vermarktungsoptionen klar und ehrlich." },
      { title: "Speicher & Wärmepumpe", text: "Beratung zur Kombination mit Batteriespeicher und Wärmepumpe." },
      { title: "Unabhängig & neutral", text: "Keine Anlagenverkäufer-Interessen – nur Ihr wirtschaftlicher Vorteil zählt." },
    ],
    stat: { value: "100 %", label: "unabhängige Empfehlung" },
  },
  waermepumpe: {
    slug: "waermepumpe",
    eyebrow: "Wärmepumpe",
    titleLines: ["Effizient heizen", 'mit der <span class="font-serif italic text-blue-700">Wärmepumpe.</span>'],
    subtitle: "Wärmepumpen brauchen den richtigen Stromtarif. Wir finden den günstigsten Wärmepumpentarif für Ihr Zuhause.",
    image: IMAGES.heatPump,
    intro: "Für Wärmepumpen gibt es spezielle, oft günstigere Stromtarife. Wir prüfen, ob ein separater Zähler oder ein kombinierter Tarif für Sie sinnvoller ist.",
    benefits: [
      { title: "Spezielle WP-Tarife", text: "Zugang zu vergünstigten Wärmepumpentarifen mit steuerbaren Verbrauchseinrichtungen." },
      { title: "Netzentgelt-Vorteile", text: "Wir prüfen reduzierte Netzentgelte nach §14a EnWG für Ihre Anlage." },
      { title: "Kombi mit PV", text: "Optimale Abstimmung von Eigenstrom und Wärmepumpenbetrieb." },
      { title: "Ehrliche Wirtschaftlichkeit", text: "Wir rechnen transparent, ob und wann sich der Wechsel lohnt." },
    ],
    stat: { value: "§14a", label: "Netzentgelt-Vorteile geprüft" },
  },
};
